import { CoreMemberMessageTemplateName } from '../../../enums'

export default {
  isSendGiftMessage: (name: CoreMemberMessageTemplateName | string | null | undefined): boolean => (
    name === CoreMemberMessageTemplateName.MEMBER_RECEIVED_GIFT ||
    name === CoreMemberMessageTemplateName.NON_MEMBER_RECEIVED_GIFT
  ),
}
